import { KlevuFilterType } from "@klevu/core";
import type { AsyncComponentLoader } from "vue";
import { FilterManagerFilterType } from "~/modules/catalog/classes/FilterManager";

export const FILTER_COMPONENTS_BY_TYPE: Record<string, AsyncComponentLoader> = {
  // Klevu filter types
  [KlevuFilterType.Options]: () => import("./Common/Options.vue"),
  [KlevuFilterType.Slider]: () => import("./Common/Slider.vue"),
  // Magento filter types
  [FilterManagerFilterType.options]: () => import("./Common/Options.vue"),
  [FilterManagerFilterType.number]: () => import("./Common/Slider.vue"),
};

export const FILTER_COMPONENTS_BY_KEYS: Record<string, AsyncComponentLoader> = {
  category: () => import("./Custom/Categories.vue"),
};
